webpackJsonp([215547489732458],{

/***/ 1533:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProviderRoleInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isDefault","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":"A list of job codes that a role maps to.","name":"jobCodes","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"permissions","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-provider-role-input-032f8f3f0b00a26ecc8a.js